// src/admin/views/MenuView.js
import { useEffect, useState } from 'react'
import { FiArchive, FiAward, FiCalendar, FiFlag, FiGlobe, FiUsers } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import { useMetaStore } from '../../scoring/store/MetaStore'
import PageHeader from '../components/PageHeader'
import { useAdminStore } from '../store/AdminStore'

function MenuView() {
  const setPageTitle = useMetaStore((state) => state.setPageTitle)
  const orgId = useAdminStore((state) => state.orgId)
  const setOrgId = useAdminStore((state) => state.setOrgId)
  const setOrgName = useAdminStore((state) => state.setOrgName)
  const [orgData, setOrgData] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
    setPageTitle('Admin')

    apiClient.get('/gskapi/org/findAllOrgs')
      .then((response) => {
        setOrgData(response.data)
      })
      .catch((error) => {
        console.error('Error fetching organization data:', error)
      })
  }, [])

  const handleOrgChange = (e) => {
    const selectedOrgId = e.target.value
    setOrgId(selectedOrgId)
    const selectedOrg = orgData.find((org) => org.orgId === selectedOrgId)
    if (selectedOrg) {
      setOrgName(selectedOrg.orgName)
    } else {
      setOrgName('')
    }
  }

  const isOrgSelected = !!orgId

  const disabledStyle = {
    opacity: 0.5,
    cursor: 'not-allowed',
  }

  return (
    <>
      <PageHeader pageName="Admin Dashboard" />
      <div style={{ maxWidth: '1000px', margin: '20px auto', padding: '0 20px' }}>
        <div className="admin-input-group">
          <label className="admin-label">Select Organization</label>
          <select
            className="admin-input"
            value={orgId}
            onChange={handleOrgChange}
          >
            <option value="">-- Select an Organization --</option>
            {orgData.map((org) => (
              <option key={org.orgId} value={org.orgId}>
                {org.orgName}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="admin-menu-grid">
        <div className="admin-menu-card" onClick={() => navigate(`/admin/orgs`)}>
          <div className="admin-menu-icon">
            <FiGlobe />
          </div>
          <div className="admin-menu-title">Organizations</div>
        </div>
        <div
          className="admin-menu-card"
          onClick={() => isOrgSelected && navigate(`/admin/courses`)}
          style={!isOrgSelected ? disabledStyle : {}}
        >
          <div className="admin-menu-icon">
            <FiFlag />
          </div>
          <div className="admin-menu-title">Courses</div>
        </div>
        <div
          className="admin-menu-card"
          onClick={() => isOrgSelected && navigate(`/admin/golfers`)}
          style={!isOrgSelected ? disabledStyle : {}}
        >
          <div className="admin-menu-icon">
            <FiUsers />
          </div>
          <div className="admin-menu-title">Golfers</div>
        </div>
        <div
          className="admin-menu-card"
          onClick={() => isOrgSelected && navigate(`/admin/events`)}
          style={!isOrgSelected ? disabledStyle : {}}
        >
          <div className="admin-menu-icon">
            <FiCalendar />
          </div>
          <div className="admin-menu-title">Events</div>
        </div>
        <div
          className="admin-menu-card"
          onClick={() => isOrgSelected && navigate(`/admin/prizes`)}
          style={!isOrgSelected ? disabledStyle : {}}
        >
          <div className="admin-menu-icon">
            <FiAward />
          </div>
          <div className="admin-menu-title">Prizes</div>
        </div>
        <div
          className="admin-menu-card"
          onClick={() => isOrgSelected && navigate(`/admin/events/archive`)}
          style={!isOrgSelected ? disabledStyle : {}}
        >
          <div className="admin-menu-icon">
            <FiArchive />
          </div>
          <div className="admin-menu-title">Archived Events</div>
        </div>
      </div>
    </>
  )
}

export default MenuView
